import styled from 'styled-components'

export const ButtonContainerModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 500px;

  @media (max-width: 767px) {
    width: 300px;
    flex-direction: column;
    gap: 10px;
  }
`
